<div>

    <kal-form-field>

        <kal-radio-group [formControl]="periodicityControl"
                         label="Affichage">

            <kal-radio *ngFor="let periodicity of periodicitiesList"
                       [value]="periodicity.value">
                {{ periodicity.label }}
            </kal-radio>

        </kal-radio-group>

    </kal-form-field>

    <kal-table #table
               [dataSource]="list"
               [columns]="columns"
               [displayedColumns]="displayedColumns">

        <tr *kalHeaderRowDef kal-header-row></tr>

        <td *kalBodyCell="table.defaultColumnName; let row; let code = code">
            {{ table.format(row, code) }}
        </td>

        <tr *kalFooterRowDef kal-footer-row></tr>
        <td *kalFooterCell="table.defaultColumnName; let row; let code = code, let index = index"
            class="gup-U-stronger">

            <span *ngIf="code === 'Libelle' else totalTemplate">Total</span>

            <ng-template #totalTemplate>
                <span>{{ total(code) | currency: 'EUR' }}</span>
            </ng-template>
        </td>

    </kal-table>

</div>
